import { useState, useEffect, useLayoutEffect, useCallback } from 'react';

export const useBreakpoint = (breakpoint, checkBreakpointOnLoad = true) => {
  const [reachedBreakpoint, setReachedBreakpoint] = useState(false);

  const checkSize = useCallback(() => {
    setReachedBreakpoint(window.innerWidth > breakpoint);
  }, [breakpoint]);

  useLayoutEffect(() => {
    if (checkBreakpointOnLoad) {
      checkSize();
    }
  }, [checkBreakpointOnLoad, checkSize]);

  useEffect(() => {
    window.addEventListener('resize', checkSize);
    return () => window.removeEventListener('resize', checkSize);
  }, [checkSize]);

  return [reachedBreakpoint, checkSize];
};
